import { makeInvertedDict } from './make_inverted_dict.js';
import type { Result } from './result.js';

export const extensionToMimeType = {
  csv: 'text/csv',
  html: 'text/html',
  json: 'application/json',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
} as const;

export type Extension = keyof typeof extensionToMimeType;
export type MimeType = (typeof extensionToMimeType)[Extension];

function isExistingExtension(ext: string): ext is Extension {
  return extensionToMimeType[ext as Extension] !== undefined;
}

export function fileMimeType(fileName: string): Result<string> {
  const index = fileName.lastIndexOf('.');
  const extension = fileName.slice(index + 1);
  if (isExistingExtension(extension)) {
    return extensionToMimeType[extension];
  }
  return new Error(`File extension not recognized: "${extension}"`);
}

export const mimeTypeToExtension = makeInvertedDict(extensionToMimeType);
